/* Mouse drag-to-scroll for horizontal strips that overflow (the product
   thumbnail row). Touch already swipes natively; this gives a mouse the
   same. A drag past a few pixels swallows the click that follows, so
   letting go over a thumbnail doesn't also select it. Snapping is paused
   while dragging, or it fights the pointer.

   Usage: add data-rf-drag-scroll to the scrolling element, or list
   selectors in RF_DRAG_SCROLL below. */
(() => {
  const RF_DRAG_SCROLL = ['.opt-pdp .thumbnail-slider .thumbnail-list'];
  const THRESHOLD = 5;

  const bind = (el) => {
    if (el.dataset.rfDragBound) return;
    el.dataset.rfDragBound = 'true';
    let startX = 0;
    let startScroll = 0;
    let dragging = false;
    let moved = false;
    let snap = '';

    el.addEventListener('dragstart', (e) => e.preventDefault());

    el.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (el.scrollWidth <= el.clientWidth + 1) return;
      dragging = true;
      moved = false;
      startX = e.clientX;
      startScroll = el.scrollLeft;
    });

    window.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      const dx = e.clientX - startX;
      if (!moved && Math.abs(dx) < THRESHOLD) return;
      if (!moved) {
        moved = true;
        snap = el.style.scrollSnapType;
        el.style.scrollSnapType = 'none';
        el.style.cursor = 'grabbing';
        el.style.userSelect = 'none';
      }
      el.scrollLeft = startScroll - dx;
    });

    window.addEventListener('pointerup', () => {
      if (!dragging) return;
      dragging = false;
      if (!moved) return;
      el.style.cursor = '';
      el.style.userSelect = '';
      // let the release settle on a thumbnail edge again
      el.style.scrollSnapType = snap;
    });

    // capture phase: runs before the thumbnail's own click handler
    el.addEventListener(
      'click',
      (e) => {
        if (!moved) return;
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      },
      true
    );
  };

  const init = () => {
    RF_DRAG_SCROLL.forEach((sel) => document.querySelectorAll(sel).forEach(bind));
    document.querySelectorAll('[data-rf-drag-scroll]').forEach(bind);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
